/**
 * @const {String} ALL_DASHBOARD_ITEMS the cache key for dashboard items
 */
export const ALL_DASHBOARD_ITEMS = 'all_dashboard_items'
export const ALL_SUBQUERIES = 'all_subqueries'
export const SELECTED_COUNTRY = 'selected_country'
export const DATE_RANGE = 'date_range'
export const COUNTRY_LIST = 'country_list'
export const DASHBOARD_ITEMS = 'dashboardItems'
export const DIMENSION_OPTIONS = 'dimension_options'
export const FILTER_STATE = 'filter_state'
export const SELECTED_CLIENT = 'selected_client'
export const CLIENT_LIST = 'client_list'
export const REPORT_ID = "report_id"

/**
 * @const {Object} config the cache
 */
const config = {}

/**
 * return a cached item by key
 * @function getItem
 * @param {String} key cache key
 * @returns
 */
export const getItem = (key) => (
    config[key]
)

/**
 * set a cached item with a key
 * @function setItem
 * @param {*} item
 * @param {String} key
 */
export const setItem = (item, key) => {
    config[key] = item
}
// unused
// const removeItem = (key) => {
//     delete config[key]
// }

/**
 * return cached dashboard items
 * @exports
 * @function getDashboardItems
 * @returns {Object} cached dashboard items
 */
const getDashboardItems = () => (
    getItem(ALL_DASHBOARD_ITEMS)//config[ALL_DASHBOARD_ITEMS]
)

/**
 * cache the dashboard items
 * @exports
 * @function setDashboardItems
 * @param {Object} dashboardItems
 */
const setDashboardItems = (dashboardItems) => {
    setItem(dashboardItems, ALL_DASHBOARD_ITEMS)
}

/* const getSubqueries = () => (
    getItem(ALL_SUBQUERIES)
)

const setSubqueries = (sq) => {
    setItem(sq || subquery, ALL_SUBQUERIES)
} */

/* const getDateRange = () => (
    getItem(DATE_RANGE)
)

const setDateRange = (dateRange) => {
    setItem(dateRange || [], DATE_RANGE)
} */

/* const getCountryList = () => (
    getItem(COUNTRY_LIST)
)

const setCountryList = (cList) => {
    setItem(cList || [{ label: "All Countries", value: "all" }], COUNTRY_LIST)
}

const getSelectedCountry = () => (
    getItem(SELECTED_COUNTRY)
)

const setSelectedCountry = (selectedCountry) => {
    setItem(selectedCountry || config[COUNTRY_LIST].find((c) => { return c.value == 'all' }), SELECTED_COUNTRY)
} */

export default {
    getDashboardItems, setDashboardItems,
    // getSubqueries, setSubqueries,
    //getSelectedCountry, setSelectedCountry,
    // getDateRange, setDateRange,
    //getCountryList, setCountryList
}
